import { render, staticRenderFns } from "./CodeForces.vue?vue&type=template&id=45ff9df5&"
import script from "./CodeForces.vue?vue&type=script&lang=js&"
export * from "./CodeForces.vue?vue&type=script&lang=js&"
import style0 from "./CodeForces.vue?vue&type=style&index=0&id=45ff9df5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports